import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";

const HeroVideo = ({ rendering, fields }) => {
  const { video, overline, headingType, headingBody, body, button, align, shadow } = fields,
    heroVideoClasses = classNames("hero-video", "grid");

  const heroVideoRef = useRef(null),
    heroVideoIsFirstChildSelector = ".hero-video:first-child",
    firstBarSelector = ".header",
    elementsToPreventTransparencySelector = [
      ".header>.second-bar:not(.transparent),.header-container>.scroll-menu", //second menu bar
      ".market-detector,.cookies", //market-detector
      ".cart-preview-container", //cart
      ".menu-main.menu-main--open,.mobile-nav-menu" //mobile menu
    ],
    yBreakpoint = 50;

  const setHeaderFirstBarBackground = backgroundColor => {
    let firstBar = document.querySelectorAll(firstBarSelector),
      elementsToPreventTransparency = document.querySelectorAll(elementsToPreventTransparencySelector.join(","));
    firstBar = firstBar?.length ? firstBar[firstBar.length - 1] : undefined;
    if (firstBar) {
      if (backgroundColor === "transparent") firstBar.style.backgroundColor = !elementsToPreventTransparency?.length && heroVideoRef.current ? "transparent" : "";
      else firstBar.style.backgroundColor = backgroundColor;
    }
  };
  let timer = null;
  const handleScroll = () => {
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      manageHeaderBackground();
    }, 50);
  };

  const handleClick = () => {
    manageHeaderBackground();
    setTimeout(() => {
      manageHeaderBackground();
    }, 1000);
  };

  const manageHeaderBackground = () => {
    window.pageYOffset < yBreakpoint && setHeaderFirstBarBackground("transparent");
    window.pageYOffset >= yBreakpoint && setHeaderFirstBarBackground("");
  };

  useEffect(() => {
    const isFirstChild = heroVideoRef.current ? (heroVideoRef.current.matches ? heroVideoRef.current.matches(heroVideoIsFirstChildSelector) : heroVideoRef.current.msMatchesSelector(heroVideoIsFirstChildSelector)) : undefined;
    if (isFirstChild) {
      setTimeout(() => {
        manageHeaderBackground();
      }, 50);
      window.addEventListener("scroll", handleScroll, false);
      window.addEventListener("click", handleClick, false);
      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("click", handleClick);
        setHeaderFirstBarBackground("unset");
      };
    }
  }, []);

  const hasContent = headingBody?.value || body?.value || button?.fields || overline?.value || align?.fields.phrase.value;

  return (
    <section ref={heroVideoRef} datasourceid={rendering ? rendering.dataSource : undefined} className={heroVideoClasses}>
      <div className="video">
        <video autoPlay loop muted webkit-playsinline playsinline>
          {video.value && <source src={video.value.src} type={video.value.mimeType} />}
        </video>
      </div>

      <div className={classNames("hero-shadow-container", align?.fields.phrase.value)}>{hasContent && shadow?.value && <div className="hero-shadow"></div>}</div>

      {overline?.value && <BodyText className={classNames("hero-overline", align?.fields.phrase.value)} html={overline?.value} />}
      {headingBody?.value && <Heading className={classNames("hero-heading", align?.fields.phrase.value)} typographyClass={"type-h1-big"} type={headingType} html={headingBody} />}
      {body?.value && <BodyText className={classNames("hero-body", align?.fields.phrase.value)} html={body?.value} />}
      {button?.fields && <PrimaryButton {...button?.fields} />}
    </section>
  );
};

HeroVideo.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    video: PropTypes.object
  }),
  overline: PropTypes.object,
  heading: PropTypes.object,
  body: PropTypes.object,
  button: PropTypes.object,
  align: PropTypes.oneOf(["left", "centered"]),
  shadow: PropTypes.bool
};

HeroVideo.defaultProps = {
  align: "centered"
};

export default HeroVideo;
